import { render, staticRenderFns } from "./HRMSyncDetailModal.vue?vue&type=template&id=67340ce6&scoped=true"
import script from "./HRMSyncDetailModal.vue?vue&type=script&lang=js"
export * from "./HRMSyncDetailModal.vue?vue&type=script&lang=js"
import style0 from "./HRMSyncDetailModal.vue?vue&type=style&index=0&id=67340ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67340ce6",
  null
  
)

export default component.exports